<app-header></app-header>
<router-outlet></router-outlet>
<app-footer></app-footer>
<eventShop-loader></eventShop-loader>
<app-modal></app-modal>
<app-toast></app-toast>
